import { useRef, useMemo } from "react";
const getVirtualIndex = (oldIndex, newIndex, count, isIncrement) => {
  if (isIncrement) {
    return newIndex < oldIndex ? oldIndex + 1 + (newIndex + 1) - 1 : newIndex;
  }
  return oldIndex < newIndex ? count - (newIndex + 1) - (0 + 1) : newIndex;
};
export const useVirtualIndex = (items, index, increment, infinite) => {
  const latestIndexRef = useRef(index);
  return useMemo(() => {
    const latestIndex = latestIndexRef.current;
    if (index === latestIndex) {
      return latestIndex;
    }
    latestIndexRef.current = index;
    if (!infinite) return index;
    return getVirtualIndex(latestIndex, index, items.length, increment);
  }, [index, increment, infinite, items]);
};
